import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { marked } from "marked"
import { memo, useMemo } from "react"
import { twMerge } from "tailwind-merge"

import styles from "./Markdown.module.css"

export const MarkdownNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props

	const { markdown } = node.attrs as { markdown: string }

	const renderedMarkdownHtml = useMemo(() => {
		if (!markdown) return null

		try {
			return marked.parse(markdown, { breaks: true }) as string
		} catch {
			return markdown
		}
	}, [markdown])

	return (
		<NodeViewWrapper>
			{renderedMarkdownHtml && (
				<div
					className={twMerge("px-4 py-3", styles.Markdown)}
					dangerouslySetInnerHTML={{ __html: renderedMarkdownHtml }}
				/>
			)}
		</NodeViewWrapper>
	)
})
MarkdownNodeComponent.displayName = "MarkdownNodeComponent"
